import { useCallback, MutableRefObject, useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EFVideo from '@/components/UI/EFVideo';
import NextImage from '@/components/NextImage';

let clientW = 0;
let clientH = 0;
let carMoveW = 0;
let carMoveH = 0;
let carMoveWidthOhter = 0;
let leadWidth = 0;
let pervNum = 0;
const zoomBoundHeight = 880;

export default function Bounds() {
    const { t } = useLang('bladeroboticlawnmower');
    const videoRef1 = useRef<MutableRefObject<any>>(null);
    const videoRef2 = useRef<MutableRefObject<any>>(null);
    const videoRef3 = useRef<MutableRefObject<any>>(null);
    const videoRef4 = useRef<MutableRefObject<any>>(null);
    const [tabActive, setTabActive] = useState<string>('1');
    const domRef = useRef<HTMLDivElement>(null);
    const domChildRef = useRef<HTMLDivElement>(null);
    const arrLeftRef = useRef<Array<number>>([0]);
    const arrWidthRef = useRef<Array<number>>([]);
    const [active, setActive] = useState<string>('');
    const boundCar = useRef<HTMLDivElement>(null);
    const zoomRef = useRef<HTMLDivElement>(null);

    // 视频异步加载延迟资源
    const [sources1, setSources1] = useState<string[] | null>(null);
    const [sources2, setSources2] = useState<string[] | null>(null);
    const [sources3, setSources3] = useState<string[] | null>(null);
    const [sources4, setSources4] = useState<string[] | null>(null);

    const initMove = useCallback((dom: any, arrHRef: number[], arrTRef: number[]) => {
        const child = dom.children;
        const len = child?.length || 0;
        for (let i = 0; i < len - 1; i++) {
            const item = child[i];
            arrHRef.push(item.clientWidth);

            if (i === len - 2) {
                break;
            }
            if (i !== 0) {
                arrTRef.push(arrTRef[i] + item.clientWidth + 60);
            } else {
                arrTRef.push(item.clientWidth + 60);
            }
        }
    }, []);

    const changeTab = useCallback((index: string) => {
        setTabActive(index);
        const ind = Number(index) - 1;

        (domChildRef.current as HTMLDivElement).style.cssText = `width: ${arrWidthRef.current[ind]}px; left: ${arrLeftRef.current[ind]}px`;
    }, []);

    // 初始化小车数据
    const initCar = useCallback(() => {
        clientW = window.innerWidth;
        clientH = window.innerHeight;

        if (clientW / clientH > 2560 / 1440) {
            // 以宽为主导
            carMoveW = clientW / 2.8;
            carMoveH = clientW / 11.5;
            carMoveWidthOhter = clientW / 14.2;
            setActive('');
            leadWidth = 0;
        } else {
            // 以高为主导
            carMoveW = clientH / 1.65;
            carMoveH = clientH / 6.49;
            carMoveWidthOhter = clientW / 9.61;
            setActive('lead-h');
            leadWidth = -clientH / 19.2;
        }
    }, []);

    useEffect(() => {
        // PC 适配小屏幕尺寸 小于840尺寸的
        const pageHeight = document.documentElement.clientHeight;
        if (pageHeight < 840) {
            const sclae = document.documentElement.clientHeight / zoomBoundHeight;
            (zoomRef.current as HTMLDivElement).style.cssText = `transform:scale(${sclae})`;
        }

        initCar();

        // 初始化tab1切换数据
        initMove(domRef.current, arrWidthRef.current, arrLeftRef.current);
        changeTab('1');

        AniContainer.create({
            asyncFromTo: [
                ['.bound-ani-01', { opacity: 0 }, { opacity: 1 }, 0.7],
                // ['.bound-ani-02', { opacity: 1, scale: 2.3 }, { opacity: 1, scale: 2.3 }, 1],
                ['.bound-ani-01', { opacity: 1, y: 0 }, { opacity: 0, y: -150 }, 0.7],
                ['.bound-ani-02', { scale: 2.3 }, { scale: 1 }, 1],
                ['.bound-ani-03', { opacity: 0, y: 290 }, { opacity: 1, y: 0 }, 1],
                ['.bound-ani-05', { opacity: 0, y: 200 }, { opacity: 1, y: 0 }, 0.4],
            ],
            // asyncTimeLine: [0, 1.8, 1.8, 3, 3.3, 3.6],
            asyncTimeLine: [0, 3, 3, 3.3, 3.6],
            triggerElement: '.bound-sec-01',
            triggerHook: 0.4,
            offset: 0,
            duration: '145%',
        });

        const video1: any = videoRef1.current;
        const video2: any = videoRef2.current;
        AniContainer.create({
            triggerElement: '.bound-sec-01',
            triggerHook: 0.9,
            offset: 0,
            duration: 0,
            onEnter: () => {
                video1?.play();
                video2?.play();
            },
            onLeave: () => {
                video1?.setCurrentTime(0);
                video2?.setCurrentTime(0);
                video1?.pause();
                video2?.pause();
            },
            isGpu: false,
            onLazyLoad: async () => {
                setSources1(['/video/blade/detail/pc/bound_car.webm', '/video/blade/detail/pc/bound_car.mp4']);
                setSources2(['/video/blade/detail/pc/bound_car_sub.webm', '/video/blade/detail/pc/bound_car_sub.mp4']);
            },
        });

        const video3: any = videoRef3.current;
        const video4: any = videoRef4.current;
        AniContainer.create({
            asyncFromTo: [
                ['.bound-cloud .cloud-01', { opacity: 0, x: 400, y: 400 }, { opacity: 1, x: 0, y: 0 }, 1],
                ['.bound-cloud .cloud-02', { opacity: 0, x: -400, y: 400 }, { opacity: 1, x: 0, y: 0 }, 1],
                ['.bound-cloud .cloud-03', { opacity: 0, x: 400, y: -400 }, { opacity: 1, x: 0, y: 0 }, 1],
                ['.bound-cloud .cloud-04', { opacity: 0, x: -400, y: -400 }, { opacity: 1, x: 0, y: 0 }, 1],
                ['.bound-cloud .cloud-05', { opacity: 0, scale: 1.2 }, { opacity: 1, scale: 1 }, 1],
                ['.bound-car', { opacity: 0 }, { opacity: 1 }, 0.2],
                ['.bound-cloud .cloud-05', { opacity: 1, scale: 1 }, { opacity: 0, scale: 1.2 }, 1],
                ['.bound-cloud .cloud-01', { opacity: 1, x: 0, y: 0 }, { opacity: 0, x: 400, y: 400 }, 1],
                ['.bound-cloud .cloud-02', { opacity: 1, x: 0, y: 0 }, { opacity: 0, x: -400, y: 400 }, 1],
                ['.bound-cloud .cloud-03', { opacity: 1, x: 0, y: 0 }, { opacity: 0, x: 400, y: -400 }, 1],
                ['.bound-cloud .cloud-04', { opacity: 1, x: 0, y: 0 }, { opacity: 0, x: -400, y: -400 }, 1],
                ['.bound-car-all .bound-car-bg', { scale: 0.92 }, { scale: 1 }, 0.8],
                // ['.bound-car-all .bound-car-bg', { scale: 1 }, { scale: 5 }, 1],
                // ['.bound-car-lawn', { opacity: 0 }, { opacity: 1 }, 0.4],
                ['.bound-car-item', { x: 0 }, { x: carMoveW }, 0.5], // point1
                ['.bound-car-item', { x: carMoveW, rotate: 0 }, { x: carMoveW + carMoveWidthOhter, rotate: 90 }, 0.25],
                ['.bound-car-item', { x: carMoveW + carMoveWidthOhter, rotate: 90, y: 0 }, { x: carMoveW + carMoveWidthOhter, rotate: 90, y: carMoveH }, 0.25],
                [
                    '.bound-car-item',
                    { x: carMoveW + carMoveWidthOhter, rotate: 90, y: carMoveH },
                    { x: carMoveW + carMoveWidthOhter / 2 + leadWidth, rotate: 180, y: carMoveH },
                    0.25,
                ], // point2
                [
                    '.bound-car-item',
                    { x: carMoveW + carMoveWidthOhter / 2 + leadWidth, rotate: 180, y: carMoveH },
                    { x: -carMoveW + carMoveWidthOhter / 2 + leadWidth, rotate: 180, y: carMoveH },
                    1,
                ],
                [
                    '.bound-car-item',
                    { x: -carMoveW + carMoveWidthOhter / 2 + leadWidth, rotate: 180, y: carMoveH },
                    { x: -carMoveW + carMoveWidthOhter / 10 + leadWidth, rotate: 90, y: carMoveH },
                    0.25,
                ],
                [
                    '.bound-car-item',
                    { x: -carMoveW + carMoveWidthOhter / 10 + leadWidth, rotate: 90, y: carMoveH },
                    { x: -carMoveW + carMoveWidthOhter / 10 + leadWidth, rotate: 90, y: carMoveH * 2 },
                    0.25,
                ],
                [
                    '.bound-car-item',
                    { x: -carMoveW + carMoveWidthOhter / 10 + leadWidth, rotate: 90, y: carMoveH * 2 },
                    { x: -carMoveW + carMoveWidthOhter / 2 + leadWidth, rotate: 0, y: carMoveH * 2 },
                    0.25,
                ],
            ],
            asyncTimeLine: [
                0,
                0,
                0,
                0,
                0,
                1,
                1.3,
                1.3,
                1.3,
                1.3,
                1.3,
                1.3,
                // 2.6,
                // 3.3,
                2.9, // point1
                3.4,
                3.65,
                3.9, // point2
                4.15,
                5.15,
                5.4,
                5.65,
            ],
            triggerElement: '.bound-sec-02',
            triggerHook: 0,
            offset: '20%',
            duration: '230%',
            onProcess: (num: number) => {
                if (num >= 0.384) {
                    (boundCar.current as HTMLDivElement).classList.add('active1');
                }

                if (pervNum > 0.384 && num <= 0.384) {
                    (boundCar.current as HTMLDivElement).classList.remove('active1');
                    (boundCar.current as HTMLDivElement).classList.add('active2');

                    setTimeout(() => {
                        (boundCar.current as HTMLDivElement).classList.remove('active2');
                    }, 800);
                }
                pervNum = num;
            },
            onLazyLoad: async () => {
                setSources3(['/video/blade/detail/pc/zones.webm', '/video/blade/detail/pc/zones.mp4']);
                setSources4(['/video/blade/detail/pc/zones_other.webm', '/video/blade/detail/pc/zones_other.mp4']);
            },
        });
    }, []);

    return (
        <div className={css['mod-bound']}>
            <div className="bound-sec-01">
                <div id="bound" className="point"></div>
                <div className="sticky-box">
                    <div className="box-center">
                        <p className="bound-title bound-ani-01">{t('detail.bounds_sec1_title')}</p>
                    </div>
                    <div className="section-magic">
                        <div className="box-center">
                            <div className="magic bound-ani-03">
                                <p className="magic-title">{t('detail.bounds_sec2_title')}</p>
                                <p className="magic-desc">{t('detail.bounds_sec2_desc')}</p>
                            </div>
                            <div className="magic-video video-box">
                                <div className="bound-ani-02">
                                    <EFVideo ref={videoRef1} className="video" autoPlay={false} sources={sources1} />
                                </div>
                                <div className="magic-min-video bound-ani-05">
                                    <EFVideo ref={videoRef2} className="video" autoPlay={false} sources={sources2} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bound-sec-02">
                <div className="sticky-box">
                    <div className="box-center">
                        <div className="box-zoom" ref={zoomRef}>
                            <p className="bound-teach-title">{t('detail.bounds_sec3_title')}</p>
                            <div className={`bound-content ani-0${tabActive}`}>
                                <div className="video-box">
                                    <EFVideo ref={videoRef3} autoPlay={true} className="video" sources={sources3} />
                                </div>
                                <div className="video-box">
                                    <EFVideo ref={videoRef4} autoPlay={true} className="video" sources={sources4} />
                                </div>
                            </div>
                            <div ref={domRef} className={`bound-tab active-0${tabActive}`}>
                                <button onClick={() => changeTab('1')}>{t('detail.bounds_sec3_tab1')}</button>
                                <button onClick={() => changeTab('2')}>{t('detail.bounds_sec3_tab2')}</button>
                                <span ref={domChildRef}></span>
                            </div>
                            <p className="bound-teach-desc">{tabActive === '1' ? t('detail.bounds_sec3_tab_desc1') : t('detail.bounds_sec3_tab_desc2')}</p>
                        </div>
                    </div>

                    <div className="cloud bound-cloud">
                        <span className="cloud-01">
                            <NextImage
                                webpSrc={require('@publicLocal/blade/detail/pc/cloud1_1_pc_2k00.webp')}
                                src={require('@publicLocal/blade/detail/pc/cloud1_1_pc_2k00.png')}
                                alt={t('detail.sec1_title')}
                                aria-label={t('detail.sec1_title')}
                            />
                        </span>
                        <span className="cloud-02">
                            <NextImage
                                webpSrc={require('@publicLocal/blade/detail/pc/cloud1_2_pc_2k00.webp')}
                                src={require('@publicLocal/blade/detail/pc/cloud1_2_pc_2k00.png')}
                                alt={t('detail.sec1_title')}
                                aria-label={t('detail.sec1_title')}
                            />
                        </span>
                        <span className="cloud-03">
                            <NextImage
                                webpSrc={require('@publicLocal/blade/detail/pc/cloud1_3_pc_2k00.webp')}
                                src={require('@publicLocal/blade/detail/pc/cloud1_3_pc_2k00.png')}
                                alt={t('detail.sec1_title')}
                                aria-label={t('detail.sec1_title')}
                            />
                        </span>
                        <span className="cloud-04">
                            <NextImage
                                webpSrc={require('@publicLocal/blade/detail/pc/cloud1_4_pc_2k00.webp')}
                                src={require('@publicLocal/blade/detail/pc/cloud1_4_pc_2k00.png')}
                                alt={t('detail.sec1_title')}
                                aria-label={t('detail.sec1_title')}
                            />
                        </span>
                        <span className="cloud-05">
                            <NextImage
                                webpSrc={require('@publicLocal/blade/detail/pc/cloud2_pc0.webp')}
                                src={require('@publicLocal/blade/detail/pc/cloud2_pc0.jpg')}
                                alt={t('detail.sec1_title')}
                                aria-label={t('detail.sec1_title')}
                            />
                        </span>
                    </div>
                    <div className="bound-car">
                        <div ref={boundCar} className={`bound-car-all ${active}`}>
                            <div className="bound-car-bg">
                                <NextImage
                                    webpSrc={require('@publicLocal/blade/detail/pc/bound_car_all.webp')}
                                    src={require('@publicLocal/blade/detail/pc/bound_car_all.jpg')}
                                    alt={t('detail.sec1_title')}
                                    aria-label={t('detail.sec1_title')}
                                />
                            </div>
                            <div className="bound-car-lawn">
                                <NextImage
                                    webpSrc={require('@publicLocal/blade/detail/pc/bound_car_bg.webp')}
                                    src={require('@publicLocal/blade/detail/pc/bound_car_bg.jpg')}
                                    alt={t('detail.sec1_title')}
                                    aria-label={t('detail.sec1_title')}
                                />
                                <div className={`ani-bound-car-05 ${active}`}>
                                    <div className="bound-car-item">
                                        <NextImage
                                            webpSrc={require('@publicLocal/blade/detail/pc/bound_car.webp')}
                                            src={require('@publicLocal/blade/detail/pc/bound_car.png')}
                                            alt={t('detail.sec1_title')}
                                            aria-label={t('detail.sec1_title')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
